import { render } from "./prestore.vue?vue&type=template&id=ed74285c&scoped=true"
import script from "./prestore.vue?vue&type=script&lang=js"
export * from "./prestore.vue?vue&type=script&lang=js"

import "./prestore.vue?vue&type=style&index=0&id=ed74285c&scoped=true&lang=css"
import "./prestore.vue?vue&type=style&index=1&id=ed74285c&lang=css"
script.render = render
script.__scopeId = "data-v-ed74285c"

export default script